import { PatchAndCurrent } from '#submission/records'
import { PriorTrxAuthPatch } from '#trxauth.prior/model'
import { DateLabel } from '#utils/datelabel'
import { useT } from 'apprise-frontend-core/intl/language'
import { Label } from 'apprise-ui/label/label'
import { useTableUtils } from 'apprise-ui/table/utils'
import { DateIcon } from 'apprise-ui/utils/icons'
import './styles.scss'

export const usePriorTrxAuthzColumns = () => {

    const t = useT()

    const { Column } = useTableUtils<PatchAndCurrent<PriorTrxAuthPatch>>()


    return <Column defaultLayout name="range"
        title={<Label icon={<DateIcon />} title={t('priortrxauthz.range_col')} />}
        render={patch => <div className='apprise-row'>{patch.priortrxauthz.authzs.map((authz, i) =>

            <Label mode='tag' key={i} noIcon className='priortrxauthz-inlined' 
                   tip={t('priortrxauthz.range_tip', { number: authz.authorisationNumber ?? "-/-", entity: authz.authorisingEntity ?? '-/-' })} 
                   title={<div className='apprise-row'><DateLabel noIcon noTip date={authz.from} />-<DateLabel noIcon noTip date={authz.to} /></div>} />

        )}
        </div>
        } />

}